// @generated by protoc-gen-es v1.10.0
// @generated from file ai/h2o/mlops/storage/v1/registered_model_version_service.proto (package ai.h2o.storage, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { RegisteredModelVersion } from "./registered_model_version_pb.js";
import { FilterRequest, PagingRequest, PagingResponse, SortingRequest } from "./listing_pb.js";

/**
 * @generated from message ai.h2o.storage.CreateModelVersionRequest
 */
export const CreateModelVersionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.CreateModelVersionRequest",
  () => [
    { no: 1, name: "registered_model_version", kind: "message", T: RegisteredModelVersion },
    { no: 2, name: "registered_model_display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message ai.h2o.storage.GetModelVersionRequest
 */
export const GetModelVersionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.GetModelVersionRequest",
  () => [
    { no: 1, name: "model_version_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message ai.h2o.storage.GetModelVersionForExperimentRequest
 */
export const GetModelVersionForExperimentRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.GetModelVersionForExperimentRequest",
  () => [
    { no: 1, name: "experiment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "filter", kind: "message", T: FilterRequest },
  ],
);

/**
 * @generated from message ai.h2o.storage.GetModelVersionsByModelRequest
 */
export const GetModelVersionsByModelRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.GetModelVersionsByModelRequest",
  () => [
    { no: 1, name: "registered_model_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message ai.h2o.storage.InactivateModelVersionRequest
 */
export const InactivateModelVersionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.InactivateModelVersionRequest",
  () => [
    { no: 1, name: "model_version_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message ai.h2o.storage.CreateModelVersionResponse
 */
export const CreateModelVersionResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.CreateModelVersionResponse",
  () => [
    { no: 1, name: "registered_model_version", kind: "message", T: RegisteredModelVersion },
  ],
);

/**
 * @generated from message ai.h2o.storage.GetModelVersionResponse
 */
export const GetModelVersionResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.GetModelVersionResponse",
  () => [
    { no: 1, name: "registered_model_version", kind: "message", T: RegisteredModelVersion },
  ],
);

/**
 * @generated from message ai.h2o.storage.GetModelVersionForExperimentResponse
 */
export const GetModelVersionForExperimentResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.GetModelVersionForExperimentResponse",
  () => [
    { no: 1, name: "registered_model_version", kind: "message", T: RegisteredModelVersion, repeated: true },
  ],
);

/**
 * @generated from message ai.h2o.storage.ListModelVersionsForModelResponse
 */
export const ListModelVersionsForModelResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.ListModelVersionsForModelResponse",
  () => [
    { no: 1, name: "model_versions", kind: "message", T: RegisteredModelVersion, repeated: true },
    { no: 2, name: "paging", kind: "message", T: PagingResponse },
  ],
);

/**
 * @generated from message ai.h2o.storage.ListModelVersionsForModelRequest
 */
export const ListModelVersionsForModelRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.ListModelVersionsForModelRequest",
  () => [
    { no: 1, name: "registered_model_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "paging", kind: "message", T: PagingRequest },
    { no: 3, name: "filter", kind: "message", T: FilterRequest },
    { no: 4, name: "sorting", kind: "message", T: SortingRequest },
  ],
);

/**
 * @generated from message ai.h2o.storage.CountModelVersionsRequest
 */
export const CountModelVersionsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.CountModelVersionsRequest",
  () => [
    { no: 1, name: "registered_model_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message ai.h2o.storage.CountModelVersionsResponse
 */
export const CountModelVersionsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.CountModelVersionsResponse",
  () => [
    { no: 1, name: "count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message ai.h2o.storage.DeleteModelVersionRequest
 */
export const DeleteModelVersionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.DeleteModelVersionRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message ai.h2o.storage.DeleteModelVersionResponse
 */
export const DeleteModelVersionResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.DeleteModelVersionResponse",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message ai.h2o.storage.BatchDeleteModelVersionRequest
 */
export const BatchDeleteModelVersionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.BatchDeleteModelVersionRequest",
  () => [
    { no: 1, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message ai.h2o.storage.BatchDeleteModelVersionResponse
 */
export const BatchDeleteModelVersionResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.BatchDeleteModelVersionResponse",
  () => [
    { no: 1, name: "delete_model_version_response", kind: "message", T: DeleteModelVersionResponse, repeated: true },
  ],
);

